/** Must be in sync with fleet backend equivalent enum  */
export enum TripStatus {
	New = 'new',
	InRoute = 'in-route',
	Done = 'done',
	Canceled = 'canceled',
}

export enum StopType {
	Pick = 'pick',
	Drop = 'drop',
	NoShow = 'noshow',
}

export enum ReservationStatus {
	New = 'new',
	OnHold = 'on_hold',
	Canceled = 'canceled',
	Routing = 'routing',
	Routed = 'routed',
	Picked = 'picked',
	Dropped = 'dropped',
	NoShow = 'noshow',
}

export enum LocationType {
	Default = 'location',
	Airport = 'airport',
}
